const initialState = () => ({
  controls_placement_id: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state, { controls_placement_id }) {
      state.controls_placement_id = controls_placement_id
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
